import isEqual from "lodash/isEqual";
import { LIMITED_ORDER_NAMES } from "PFApp/booking/parts/overview/booking_module_calendar/side_panel_header/actions_bar/order_selector/use_order_option_mapper";
import { isValueEmpty } from "PFCore/helpers/filters";
import { FilterV2 } from "PFCore/types/filters_v2";
import { OrderOption } from "PFTypes";

const MOST_RELEVANT_ORDER = { name: ["scores.term_score"], text: "Most relevant", direction: "desc" };

export const resetOrderIfLimited = (order: OrderOption | null, onOrderReset: VoidFunction) => {
  const orderName = order && "name" in order ? order.name.join() : null;
  const hasPerformanceHeavySorting =
    !!orderName && LIMITED_ORDER_NAMES.some((name) => orderName.includes(name));
  if (hasPerformanceHeavySorting) {
    onOrderReset();
  }
};

export const resetOrderToMostRelevantIfApplicable = (
  termFilter: FilterV2 | undefined,
  order: OrderOption | null,
  setOrder: (order: OrderOption | null) => void
) => {
  if (termFilter) {
    if (!isValueEmpty(termFilter?.value)) {
      setOrder(MOST_RELEVANT_ORDER);
      return;
    }
    const isSelectedOrderMostRelevant =
      !!order && "name" in order && isEqual(order.name, MOST_RELEVANT_ORDER.name);
    if (isSelectedOrderMostRelevant) {
      setOrder(null);
    }
    return;
  }
};
